// core stamps summary.start_source; without a position report the remaining
// route starts at a position estimated on the plan.
export const ESTIMATED_START = "estimated_position";
export const ESTIMATED_START_MESSAGE =
  "No position report available — the route was calculated from the vessel's estimated position on the plan.";
